<template>
  <div
    id="audio-playlist-player"
    class="
      layout/bottom:0%
      layout/fixed
      layout/width:100%
    "
    >
    <audio
      id="tour-stop-audio"
      ref="audio"
      preload="metadata"
      @ended="onEnded"
      @loadedmetadata="onLoadedMetadata"
      @playing="onPlaying"
      @timeupdate="onTimeUpdate"
    >
      <source :src="audioSource">
    </audio>
    <TrackSeekbarFrame
      v-if="duration !== 0"
      :current-time="currentTime"
      :duration="duration"
      :init-playing="initPlaying"
      :is-playing="isPlaying"
      @click-to="onClickTo"
      @scrub-to="onScrubTo"
    />
    <PlayerControls
      ref="controls"
      aria-controls="tour-stop-audio"
      :first-tour-stop-id="firstTourStopId"
      :is-current-last="isCurrentLast"
      :is-playing="isPlaying"
      :last-tour-stop-id="lastTourStopId"
      :next-stop-id="nextStopId"
      :previous-stop-id="previousStopId"
      :total-tour-stop-count="totalTourStopCount"
      :tour-id="tourId"
      :tour-stop-id="tourStopId"
      @pause="onPause"
      @play="onPlay"
    />
  </div>
</template>

<script>
  /**
   * The Audio Player that exists in Tour Stop Show /playlist/<PLAYLIST_ID>/<STOP_ID>.
   */
  import AnalyticsMixin from '../shared/audio-analytics-mixin';
  import TrackSeekbarFrame from './track-seekbar-frame.vue';
  import PlayerControls from './player-controls.vue';

  export default {
    components: {
      TrackSeekbarFrame,
      PlayerControls
    },
    mixins: [ AnalyticsMixin ],
    props: {
      audioSource: { type: String, required: true },
      firstTourStopId: { type: Number, required: true },
      lastTourStopId: { type: Number, required: true },
      nextStopId: { type: Number, required: true },
      previousStopId: { type: Number, required: true },
      totalTourStopCount: { type: Number, required: true },
      tourId: { type: Number, required: true },
      tourStopId: { type: Number, required: true },
    },
    data() {
      return {
        currentTime: 0,
        duration: 0,
        isPlaying: false,
        initPlaying: false,
      };
    },
    computed: {
      isCurrentLast() {
        return this.tourStopId === this.lastTourStopId;
      },
    },
    methods: {
      onClickTo(data) {
        this.$refs.audio.currentTime = this.currentTime = data.seconds;
      },
      onEnded() {
        this.currentTime = 0;
        this.$refs.controls.toggleAudio();

        if (this.isCurrentLast) this.$refs.controls.showRepeat();
      },
      onLoadedMetadata() {
        this.duration = this.$refs.audio.duration;
      },
      onPause() {
        this.$refs.audio.pause();
        this.isPlaying = false;
      },
      onPlay() {
        this.$refs.audio.play();
        this.isPlaying = true;
      },
      onPlaying() {
        if (!this.initPlaying) {
          this.initPlaying = true;
        }
      },
      onScrubTo(data) {
        this.$refs.audio.currentTime = this.currentTime = data.seconds;
      },
      onTimeUpdate() {
        this.currentTime = this.$refs.audio.currentTime;

        const offset = (this.$refs.audio.currentTime / this.$refs.audio.duration) * 100;
        this.$_pushAudioPlaybackEvent(this.tourStopId, offset);
      },
    }
  };
</script>
